import { useApolloClient } from '@apollo/client';
import { Button, message } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { type AuthorizationProps } from '.';
import {
    CreateSdmAuthorizationDocument,
    type CreateSdmAuthorizationMutation,
    type CreateSdmAuthorizationMutationVariables,
} from '../../../../../api/mutations/createSDMAuthorization';
import NoItemResult from '../../../../../components/results/NoItemResult';

const AuthorizationEmpty = ({ module }: AuthorizationProps) => {
    const { t } = useTranslation(['sdmModuleDetails']);
    const apolloClient = useApolloClient();
    const createAuthorization = useCallback(async () => {
        message.loading({
            content: t('sdmModuleDetails:messages.creatingAuthorization'),
            key: 'primary',
            duration: 0,
        });

        await apolloClient.mutate<CreateSdmAuthorizationMutation, CreateSdmAuthorizationMutationVariables>({
            mutation: CreateSdmAuthorizationDocument,
            variables: {
                moduleId: module.id,
            },
        });

        message.success({
            content: t('sdmModuleDetails:messages.createAuthorization'),
            key: 'primary',
        });
    }, [apolloClient, module.id, t]);

    return (
        <NoItemResult
            extra={
                <Button onClick={createAuthorization} type="primary">
                    {t('sdmModuleDetails:actions.createSDMAuthorization')}
                </Button>
            }
            subTitle={t('sdmModuleDetails:tabs.authorization.noData')}
        />
    );
};

export default AuthorizationEmpty;
